// extracted by mini-css-extract-plugin
module.exports = {"produtos":"ProdutosHome_produtos__1Rl3E","title":"ProdutosHome_title__2WTKg"};